module.exports = __webpack_public_path__ + "static/img/kcLogo.e2ab3d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/kcLogo.png
// module id = JUmq
// module chunks = 16